import React from 'react';
import { getLoginPage } from '../../routes';
import { AuthedErrorBoundary } from '../common/components/errors/boundaries/AuthedErrorBoundary';
import { AuthenticatedContextProvider } from '../context/AuthenticatedContextProvider';
import {
  AuthUserContext,
  useEnvironmentServiceContext,
} from '../context/contexts';
import { SimulatedRoleContextProvider } from '../context/SimulatedRoleContextProvider';
import { useAuthenticatedUser } from './hooks';

export const AuthenticationGuard = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const environmentService = useEnvironmentServiceContext();
  const authUser = useAuthenticatedUser();

  if (authUser === null) {
    return getLoginPage(environmentService);
  }

  return (
    <SimulatedRoleContextProvider>
      <AuthUserContext.Provider value={authUser}>
        <AuthenticatedContextProvider>
          <AuthedErrorBoundary>{children}</AuthedErrorBoundary>
        </AuthenticatedContextProvider>
      </AuthUserContext.Provider>
    </SimulatedRoleContextProvider>
  );
};
